import { RetailerLocation } from '@andromeda/shopping-cart-data-access-store';
import {
    getAuthTgt,
    Offer,
    TgtItems,
} from '@andromeda/polaris-data-access-products';
import IProductSlot from '../../models/ProductSlot';

export const buildUrl = async (selectedRetailer: RetailerLocation, selectedProducts: IProductSlot<Offer>[]): Promise<string> => {
    if (!selectedRetailer.accessPointId) {
        const targetUri = new URL('http://www.target.com/');
        return targetUri.toString();
        // eslint-disable-next-line no-else-return
    } else {
        const itemIds: string[] = [];
        const itemsSend: TgtItems[] = [];
        selectedProducts.forEach(p => itemIds.push(p.id));
        itemIds.filter(id => id.length).forEach((id: string, i: number) => {
            // eslint-disable-next-line new-cap
            itemsSend.push(new TgtItems(1, id));
        });
        let token = '';
        try {
            const [response, error] = await getAuthTgt(itemsSend, selectedRetailer.accessPointId);
            if (error) {
                console.error(error);
                const targetUri = new URL('http://www.target.com/');
                return targetUri.toString();
            }
            if (!response.accessToken.length) {
                const targetUri = new URL('http://www.target.com/');
                return targetUri.toString();
            }
            token = response.accessToken;
        } catch (exception) {
            console.error(exception);
        }
        const targetUri = `https://www.target.com/co-cart?access_token=${token}`;
        return targetUri;
    }
};

const handleClick = async (selectedRetailer: RetailerLocation, selectedProducts: IProductSlot<Offer>[]): Promise<void> => {
    // Send one event per product because redshift can't handle large json values
    const uri = buildUrl(selectedRetailer, selectedProducts);
    window.open(await uri, '_blank');
};
export default handleClick;
